import { useMemo } from 'react';

import { stringFormatter } from '@dreryk/react-common';
import { createDynamicColumnsWidth, Table, TableColumnConfiguration } from '@dreryk/react-components';

import { draftPrescriptionsTranslationKeys } from '../../../../../../translations';

type MedicineWithSelectedReimbursement = {
   id: number;
   medicineName: string;
   reimbursement: string;
};

const useColumns = (): TableColumnConfiguration<MedicineWithSelectedReimbursement>[] => {
   const columnsWidths = createDynamicColumnsWidth({
      reimbursement: '102px',
      medicineName: '100%',
   });
   return useMemo(
      () => [
         {
            name: 'reimbursement',
            label: draftPrescriptionsTranslationKeys.reimbursement,
            accessor: 'reimbursement',
            formatter: stringFormatter,
            sortingDisabled: true,
            width: columnsWidths.reimbursement,
         },
         {
            name: 'medicineName',
            label: draftPrescriptionsTranslationKeys.medicineName,
            accessor: 'medicineName',
            formatter: stringFormatter,
            sortingDisabled: true,
            width: columnsWidths.medicineName,
         },
      ],
      [columnsWidths.medicineName, columnsWidths.reimbursement]
   );
};

type PatientMedicinesWithReimbursementsTableProps = {
   readonly medicinesWithReimbursements: MedicineWithSelectedReimbursement[];
};

export const PatientMedicinesWithReimbursementsTable = (
   props: PatientMedicinesWithReimbursementsTableProps
): JSX.Element => {
   return (
      <Table<MedicineWithSelectedReimbursement>
         testId={'patientMedicinesWithReimbursementsTable'}
         columns={useColumns()}
         dataConfiguration={{
            data: props.medicinesWithReimbursements,
         }}
         keyExtractor={(medicine) => medicine.id}
         compact
      />
   );
};
